// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/elt-operating-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/elt-operating-procedures/elt-operating-procedures.js';
import g1 from '../lessons/air-law/elt-operating-procedures/elt-testing-and-accidental-activation.js';
import g2 from '../lessons/air-law/elt-operating-procedures/permanently-mounted-elt-check.js';

mount([g0, g1, g2]);
